export const authEndpoints = {
  signIn: '/auth/sign-in',
  signOut: '/auth/sign-out',
  accessToken: '/auth/access-token',
  me: '/auth/me',
  forgotPassword: '/auth/forgot-password',
  resetPassword: '/auth/reset-password',
} as const

export const AUTH_USER_KEY = ['authUser'] as const

// Backend `features/auth/enums/auth_response_status_enum.py` kodları.
export const authBackendErrors = {
  GENERAL_ERROR: 'Bir hata oluştu. Lütfen tekrar deneyin.',
  AUTH_INVALID_CREDENTIALS: 'E-posta veya parola hatalı.',
  AUTH_INACTIVE: 'Hesabınız pasif durumda.',
  AUTH_INVALID_TOKEN: 'Geçersiz veya süresi dolmuş oturum.',
  AUTH_EMAIL_EXISTS: 'Bu e-posta zaten kayıtlı.',
  AUTH_INVALID_RESET_TOKEN: 'Sıfırlama bağlantısı geçersiz veya süresi dolmuş.',
  AUTH_WEAK_PASSWORD: 'Şifre güvenlik kurallarını karşılamıyor.',
  AUTH_PASSWORD_MISMATCH: 'Şifreler eşleşmiyor.',
} as const

export const authSuccessMessages = {
  signIn: 'Giriş başarılı!',
  forgotPassword: 'Sıfırlama linki e-posta adresinize gönderildi.',
  resetPassword: 'Şifreniz güncellendi. Giriş yapabilirsiniz.',
} as const
